import {
    CLEAR_ERROR,
    SET_MESSAGE,
    CLEAR_MESSAGE,
    SET_AUTHENTICATED,
    SET_UNAUTHENTICATED,
    SET_USER,
    SET_ERROR,
    SET_LOADING,
    STOP_LOADING
  } from "./types";
  
  import AuthService from "../../services/auth.service";
  
  
  export const login = (e) => (dispatch) => {

    dispatch({
      type: SET_LOADING,
    });

    return AuthService.login(e).then(
      (data) => {
        dispatch({
          type: SET_USER,
          payload:  data.user,
        });
        dispatch({
          type: STOP_LOADING,
        });
        return data.user
      },
      (error) => {
        if(error.response){
          dispatch({
            type: SET_MESSAGE,
            payload: { ...error.response.data, type: 'error' }
          });
        }
        dispatch({
          type: STOP_LOADING,
        });
        return Promise.reject();
      }
    );
  };

  export const getUserDetails = (e) => (dispatch) => {
    dispatch({
      type: SET_LOADING,
    });
    return AuthService.getUserDetails(e).then(
      (data) => {
        dispatch({
          type: SET_USER,
          payload:  data
        });
        dispatch({
          type: STOP_LOADING,
        });
        return Promise.resolve();
      },
      (error) => {
        dispatch({
          type: SET_ERROR,
        });
        dispatch({
          type: STOP_LOADING,
        });
        dispatch(logout())
        return Promise.reject();
      }
    );
  };
  
  export const logout = () => (dispatch) => {
    
    dispatch({
      type: SET_LOADING,
    });
       return AuthService.logout().then(
        () => {
              
    dispatch({
      type: SET_UNAUTHENTICATED,
    });
    dispatch({
      type: STOP_LOADING,
    });
          return Promise.resolve();
        },
        (error) => {
              
    dispatch({
      type: SET_UNAUTHENTICATED,
    });
    dispatch({
      type: STOP_LOADING,
    });
          return Promise.reject();
        }
      );
  };


  
  export const forgotPin = (data) => (dispatch) => {
    console.log(data);
    dispatch({
      type: SET_LOADING,
    });
    return AuthService.forgotPin(data).then(
      (response) => {
        console.log(response)
        dispatch({
          type: SET_MESSAGE,
          payload: response
        });

        dispatch({
          type: STOP_LOADING,
        });
        return response.url;
      },
      (error) => {
        console.log(error.response)
        if(error.response){
          dispatch({
            type: SET_MESSAGE,
            payload: error.response.data
          });


        }
        dispatch({
          type: STOP_LOADING,
        });
        return Promise.reject();
      }
    );
  };
  
 